module.exports = __webpack_public_path__ + "img/python.cd3e992.svg";